import { createFileRoute } from "@tanstack/react-router";
import { FounderResourcesIndexComponent } from "@/pages/founder-resources/index";
import { head, loader } from "@/pages/founder-resources/index.meta";

export const Route = createFileRoute("/$locale/founder-resources/")({
  loader,
  head,
  component: FounderResourcesIndexComponent,
});
